export default __webpack_public_path__ + "096b9c29fe4972da5c7d9dd5144d8adc.svg";